var _path;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgIconPhone = function SvgIconPhone(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 15,
    viewBox: "0 0 14 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.4163 9.95111L10.5113 9.73361C10.0538 9.68111 9.60384 9.83861 9.28134 10.1611L7.90134 11.5411C5.77884 10.4611 4.03884 8.72861 2.95884 6.59861L4.34634 5.21111C4.66884 4.88861 4.82634 4.43861 4.77384 3.98111L4.55634 2.09111C4.46634 1.33361 3.82884 0.763611 3.06384 0.763611H1.76634C0.918843 0.763611 0.213843 1.46861 0.266343 2.31611C0.663843 8.72111 5.78634 13.8361 12.1838 14.2336C13.0313 14.2861 13.7363 13.5811 13.7363 12.7336V11.4361C13.7438 10.6786 13.1738 10.0411 12.4163 9.95111Z",
    fill: "#313336"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgIconPhone);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "icon-phone.121322a5620e2c463cf6aa12ef149255.svg";